import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from "react";
import { useIntl } from "react-intl";
export var NothingFound = function NothingFound(_ref) {
  var search = _ref.search;
  var intl = useIntl();
  return React.createElement("div", {
    className: "search__products--not-found"
  }, React.createElement("p", {
    className: "u-lead u-lead--bold u-uppercase"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Sorry, but we couldn’t match any search results for: ",
    "id": "components.OverlayManager.Search.NothingFound.3844405205"
  }, "id", "components.OverlayManager.Search.NothingFound.3844405205")), search), React.createElement("p", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Don’t give up - check the spelling, think of something less specific and then use the search bar above.",
    "id": "components.OverlayManager.Search.NothingFound.1777769494"
  }, "id", "components.OverlayManager.Search.NothingFound.1777769494"))));
};
export default NothingFound;